
import React from 'react'
import './View.css';
import More from './More';


const View = () => {
  return (
    <div>
       <div className="counter-wrapper35">
       <div className="counter35">
           <h1 className='count35' >PP Woven Fabric</h1>
          
           {/* <Button > <a href="/Contact">Contact Us</a></Button> */}
       </div>
      
      
     </div>

     <More />
    </div>
  )
}

export default View
